const ORDER_BASE_PATH = '/v2/mypage/reservations/tour-ticket'
const VOUCHER_BASE_PATH = '/v2/tour-ticket/voucher'

const REDIRECT_PATHS = {
  '/ko/account/order-history': ORDER_BASE_PATH,
  '/ko/account/order-cancellation-refund-history': `${ORDER_BASE_PATH}/cancellations`,
  '/ko/account/coupon-list': '/v2/mypage/coupon/tour-ticket',
  '/ko/account/new-coupon-list': '/v2/mypage/coupon/tour-ticket/available',
  '/ko/account/content/qna': '/v2/mypage/inquiry/tour-ticket',
  '/ko/account/content/review': '/v2/mypage/reviews/tour-ticket',
  '/ko/account/voucher': `${ORDER_BASE_PATH}/voucher`,
  '/ko/account/voucher-preview': `${VOUCHER_BASE_PATH}/preview`,
  '/ko/voucher/email': `${VOUCHER_BASE_PATH}/email`,
}

const getMypageRedirectUrl = ({ fullPath, referrer, hanatourHost }) => {
  if (typeof fullPath !== 'string' || !fullPath.startsWith('/ko/')) {
    return null
  }

  // 쿼리의 순서·중복 키·인코딩과 해시를 재직렬화하지 않고 그대로 보존한다.
  const matchedUrl = fullPath.match(/^([^?#]*)(\?[^#]*)?(#.*)?$/)
  if (!matchedUrl) {
    return null
  }

  const pathname = matchedUrl[1].replace(/\/$/, '')
  const query = matchedUrl[2] || ''
  const hash = matchedUrl[3] || ''
  let redirectPath = REDIRECT_PATHS[pathname]

  if (pathname === '/ko/account/order-cancellation-refund') {
    const orderId = new URLSearchParams(query).get('id')
    redirectPath = orderId
      ? `${ORDER_BASE_PATH}/${encodeURIComponent(orderId)}/cancel`
      : ORDER_BASE_PATH
  }

  const orderDetail = pathname.match(/^\/ko\/account\/order-details\/([^/]+)$/)
  const cancellationDetail = pathname.match(
    /^\/ko\/account\/order-cancellation-refund-detail\/([^/]+)$/
  )
  if (orderDetail) {
    redirectPath = `${ORDER_BASE_PATH}/${orderDetail[1]}`
  } else if (cancellationDetail) {
    redirectPath = `${ORDER_BASE_PATH}/cancellations/${cancellationDetail[1]}`
  }

  if (!redirectPath) {
    return null
  }

  let redirectOrigin = new URL(hanatourHost).origin
  try {
    const referrerUrl = new URL(referrer)
    if (
      ['http:', 'https:'].includes(referrerUrl.protocol) &&
      referrerUrl.hostname.includes('hanatour.com')
    ) {
      redirectOrigin = referrerUrl.origin
    }
  } catch {
    // Referer가 없거나 URL로 해석할 수 없으면 환경별 기본 호스트를 사용한다.
  }

  return `${redirectOrigin}${redirectPath}${query}${hash}`
}

// 인증 쿼리·해시와 주문 ID를 제외한 URL만 로그에 남긴다.
const getMypageRedirectLogUrl = (url) =>
  url
    .split(/[?#]/)[0]
    .replace(
      /(\/ko\/account\/(?:order-details|order-cancellation-refund-details?)\/)[^/]+/,
      '$1:orderId'
    )
    .replace(/(\/v2\/mypage\/reservations\/tour-ticket\/cancellations\/)[^/]+/, '$1:orderId')
    .replace(
      /(\/v2\/mypage\/reservations\/tour-ticket\/)(?!cancellations(?:\/|$)|voucher(?:\/|$))[^/]+/,
      '$1:orderId'
    )

const createMypageRedirectMiddleware = (hanatourHost, onRedirect) => (req, res, next) => {
  if (req.method !== 'GET' && req.method !== 'HEAD') {
    return next()
  }

  const redirectUrl = getMypageRedirectUrl({
    fullPath: req.originalUrl,
    referrer: req.headers.referer,
    hanatourHost,
  })
  if (!redirectUrl) {
    return next()
  }

  res.set('Cache-Control', 'no-store')
  if (onRedirect) {
    onRedirect(req, redirectUrl)
  }
  return res.redirect(301, redirectUrl)
}

module.exports = {
  getMypageRedirectUrl,
  getMypageRedirectLogUrl,
  createMypageRedirectMiddleware,
}
